import styled from "styled-components";
import {Table} from "antd";

export const TableContainer = styled(Table)`
    width: 100%;
    flex: 1;
    & > div > div > div > div > div > table > tbody > tr > td > span:before {
        content: "";
    }

    @media screen and (max-width: 992px) {
        & > div > div > div > div > div > table {
            width: 100%;
        }
        & > div > div > div > div > div > table > .ant-table-thead {
            display: none;
        }
        & > div > div > div > div > div > table > .ant-table-tbody {
            width: 100%;
        }
        & > div > div > div > div > div > table > .ant-table-tbody > .ant-table-row {
            outline: 1px solid #f0f0f0;
            margin-bottom: 20px;
            margin-top: 20px;
            display: flex;
            flex-direction: column;
            box-shadow: 0px 4px 4px 0px rgba(214, 214, 214, 1);
        }
        &
            > div
            > div
            > div
            > div
            > div
            > table
            > .ant-table-tbody
            > .ant-table-row
            > .ant-table-cell {
            border-bottom: 1px solid #f0f0f0;
            padding: 10px 12px !important;
            width: 100%;
            &:last-child {
                border-bottom: none;
            }
        }
        & > div > div > div > div > div > table > tbody > tr > td > span {
            display: flex;
            flex-direction: column;
            gap: 4px;
            word-break: break-word;
        }
        & > div > div > div > div > div > table > tbody > tr > td > span:before {
            content: attr(data-label);
            font-weight: bold;
            font-size: 12px;
            color: #666;
            margin-bottom: 2px;
        }
        & > div > div > div > div > div > table > tbody > tr > td > span > * {
            word-break: break-word;
        }
    }
`;

export const ActionButtons = styled.div`
    flex-direction: row;
`;

export const ResponsiveModalContainer = styled.div`
    @media screen and (max-width: 768px) {
        .ant-modal {
            max-width: 100vw !important;
            margin: 0 !important;
            top: 0 !important;
            padding-bottom: 0 !important;
        }
        
        .ant-modal-content {
            border-radius: 0 !important;
        }
    }
`;
